var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLSmartPhoneMIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 2.5C0.125 1.12109 1.24609 0 2.625 0H11.375C12.7539 0 13.875 1.12109 13.875 2.5V17.5C13.875 18.8789 12.7539 20 11.375 20H2.625C1.24609 20 0.125 18.8789 0.125 17.5V2.5ZM5.125 17.5C5.125 17.8438 5.40625 18.125 5.75 18.125H8.25C8.59375 18.125 8.875 17.8438 8.875 17.5C8.875 17.1562 8.59375 16.875 8.25 16.875H5.75C5.40625 16.875 5.125 17.1562 5.125 17.5ZM11.375 2.5H2.625V15H11.375V2.5Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLSmartPhoneMIcon);
export default __webpack_public_path__ + "static/media/l_smartPhone_m_icon.ffaf9318e50b022aca058f31536458dc.svg";
export { ForwardRef as ReactComponent };